import React from 'react';
import { palette, principles, shopifyMapping, typography } from '../../data/designGuide';
export function DesignGuide() {
  return <div className="space-y-24" data-id="element-8" data-mp="lsq4j3tuq8r0">
      <section aria-labelledby="paleta-titulo" data-id="element-9" data-mp="lpvodohvfa3e">
        <h2 id="paleta-titulo" className="font-serif text-3xl text-carbon" data-id="element-10" data-mp="qq9s4ucfvxvm">Paleta</h2>
        <ul className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-11" data-mp="vi9o6bpe26mx">
          {palette.map(color => <li key={color.hex} data-id="element-12" data-mp="ziladsxegf0i">
              <div className="h-20 rounded-sm border border-sand" style={{
            backgroundColor: color.hex
          }} data-id="element-13" data-mp="zlpkf6xjq4z3" />
              <p className="mt-3 text-sm font-medium text-carbon" data-id="element-14" data-mp="14ksn4kq1zz3w">{color.name}</p>
              <p className="text-xs text-stone" data-id="element-15" data-mp="19ikglj6cjta7">{color.hex}</p>
              <p className="mt-2 text-sm leading-relaxed text-stone" data-id="element-16" data-mp="1eh5jjqczgr2c">{color.use}</p>
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="tipografia-titulo" data-id="element-17" data-mp="3bb09a7acbnhy">
        <h2 id="tipografia-titulo" className="font-serif text-3xl text-carbon" data-id="element-18" data-mp="3g7gy73pd65w3">Tipografía</h2>
        <div className="mt-8 grid gap-10 border-t border-sand pt-8 lg:grid-cols-2" data-id="element-19" data-mp="2b4h9jfc4lxbx">
          {typography.map(type => <div key={type.family} data-id="element-20" data-mp="26ch1ezlwjy49">
              <p className="text-sm text-stone" data-id="element-21" data-mp="26bfosqp8n3kf">
                {type.family} · {type.role}
              </p>
              <p className={`mt-4 text-carbon ${type.className}`} data-id="element-22" data-mp="1wf2xfzh611su">{type.sample}</p>
              <p className="mt-4 text-sm leading-relaxed text-stone" data-id="element-23" data-mp="1wczyur1y60ci">{type.notes}</p>
            </div>)}
        </div>
      </section>

      <section aria-labelledby="criterios-titulo" data-id="element-24" data-mp="2p3gvugc6204x">
        <h2 id="criterios-titulo" className="font-serif text-3xl text-carbon" data-id="element-25" data-mp="2p1nmuue2z3tr">Criterios de diseño</h2>
        <ul className="mt-8 divide-y divide-sand border-y border-sand" data-id="element-26" data-mp="2k6qg5u49x6k1">
          {principles.map(item => <li key={item.title} className="grid gap-2 py-6 md:grid-cols-[280px_1fr] md:gap-10" data-id="element-27" data-mp="18picjb1gbugx">
              <p className="font-serif text-xl text-carbon" data-id="element-28" data-mp="18n5ocg53onvf">{item.title}</p>
              <p className="text-base leading-relaxed text-stone" data-id="element-29" data-mp="14mlp970yva6n">{item.body}</p>
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="shopify-titulo" data-id="element-30" data-mp="1b3viu6i2jrcw">
        <h2 id="shopify-titulo" className="font-serif text-3xl text-carbon" data-id="element-31" data-mp="1b3n7wk5iaw4c">Implementación en Shopify Horizon</h2>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-stone" data-id="element-32" data-mp="w8z4rcnkw9rw">
          Todo vive en una plantilla de producto propia, así la identidad global de Buena VibraX y los
          demás productos no cambian. Los nombres de secciones pueden variar según tu versión de
          Horizon.
        </p>
        <div className="mt-8 overflow-x-auto" data-id="element-33" data-mp="s7dtfvqp03jt">
          <table className="w-full min-w-[640px] border-t border-sand text-left text-sm" data-id="element-34" data-mp="dh6dbmo5qwma">
            <thead data-id="element-35" data-mp="ieyb2xbhhcye">
              <tr className="border-b border-sand text-stone" data-id="element-36" data-mp="ig9id74512u9">
                <th scope="col" className="py-3 pr-6 font-medium" data-id="element-37" data-mp="4fysa6anjsa5">Elemento</th>
                <th scope="col" className="py-3 pr-6 font-medium" data-id="element-38" data-mp="4i2tuhl2wf79">Tipo</th>
                <th scope="col" className="py-3 font-medium" data-id="element-39" data-mp="8giliys3ubr0">Cómo reproducirlo</th>
              </tr>
            </thead>
            <tbody data-id="element-40" data-mp="3m08nyv4xrctj">
              {shopifyMapping.map(row => <tr key={row.section} className="border-b border-sand align-top" data-id="element-41" data-mp="3h0vpfd4pchb4">
                  <th scope="row" className="py-4 pr-6 font-medium text-carbon" data-id="element-42" data-mp="3v05428d9f3cz">{row.section}</th>
                  <td className="whitespace-nowrap py-4 pr-6" data-id="element-43" data-mp="3pyxx2bixy87d">
                    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-medium ${row.native === 'Nativo' ? 'bg-ivory text-carbon' : row.native === 'Código personalizado' ? 'bg-carbon text-ivory' : 'border border-gold text-gold-ink'}`} data-id="element-44" data-mp="8rm2psf4yt0e">
                      {row.native}
                    </span>
                  </td>
                  <td className="py-4 leading-relaxed text-stone" data-id="element-45" data-mp="mkbopwunzxxi">{row.how}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </section>
    </div>;
}